<template>
    <v-flex class="roles" v-if="isSectionVisible || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.PROFESSIONAL_OUTSIDE}}<v-flex tag="em" v-if="isSeeAllVisible" data-qe-id="see-all_professional-roles_link" @click="seeAllRoles()">{{isEnabled}}</v-flex>
            <i v-if="isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id="open_professional-roles_dialog" @click="professionalRolesDialog = true"></i>
        </v-flex>
        <v-flex>
            <v-flex v-if="!isSectionVisible && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.ROLES}} </v-flex>
            <status-overlay :action="loadGetProfessionalRolesAction" content-height="200px">
            </status-overlay>
        </v-flex>  
        <v-layout row wrap>
            <v-flex xs12 sm4 v-if="externalBoardPositionList.length != 0">
                <v-flex tag="strong">{{memberProfileConstants.EXTERNAL_BOARD_OF_DIRECTORS}}</v-flex>
                <v-flex v-if="!enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in externalBoardPositionList.slice(0,1)" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
                <v-flex v-if="enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in externalBoardPositionList" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex xs12 sm4 v-if="publicServiceList.length != 0">
                <v-flex tag="strong">{{memberProfileConstants.PUBLIC_SERVICE}}</v-flex>
                <v-flex v-if="!enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in publicServiceList.slice(0,1)" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
                <v-flex v-if="enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in publicServiceList" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex xs4 v-if="volunteerList.length != 0">
                <v-flex tag="strong">{{memberProfileConstants.VOLUNTEER_ROLES}}</v-flex>
                <v-flex v-if="!enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in volunteerList.slice(0,1)" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
                <v-flex v-if="enabled">
                    <v-flex class="roles__dataRow" v-for="(professionalRole, index) in volunteerList" :key="index">
                        <v-flex tag="span" v-if="professionalRole.url">
                            <a data-qe-id="professionalRole_title" :href="normalizeUrl(professionalRole.url)" target="_blank">
                                {{professionalRole.name}}
                            </a>
                        </v-flex>
                        <v-flex class="tag" v-if="!professionalRole.url">
                            {{professionalRole.name}}
                        </v-flex>
                        <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-dialog scrollable v-model="professionalRolesDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.PROFESSIONAL_ROLES.EDIT}}
                    <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="professionalRolesDialog = false"></i>
                </v-card-title>
                <v-card-text ref="professionalScroll" class="inner-scrollbar">
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.PROFESSIONAL_ROLES.EXTERNAL_BOARDS}}
                            <span class="add-edit-btn" data-qe-id="open_external-boards_dialog" @click="openProfessionalDialog(memberProfileConstants.DATA_EXTERNAL_BOARD_POSITION)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="row__list" v-for="(professionalRole, index) in professionalRolesEdit[memberProfileConstants.DATA_EXTERNAL_BOARD_POSITION]" :key="index">
                            <v-flex tag="small">{{professionalRole.name}}<i class="fas fa-pencil-alt" :data-qe-id="`edit_professional-role_${index}`" @click="editProfessionalRoles(professionalRole)"></i> </v-flex>
                            <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.PROFESSIONAL_ROLES.PUBLIC_SERVICES}}
                            <span class="add-edit-btn" data-qe-id="open_public-services_dialog" @click="openProfessionalDialog(memberProfileConstants.DATA_PUBLIC_SERVICE)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="row__list" v-for="(professionalRole, index) in professionalRolesEdit[memberProfileConstants.DATA_PUBLIC_SERVICE]" :key="index">
                            <v-flex tag="small">{{professionalRole.name}}<i class="fas fa-pencil-alt" :data-qe-id="`edit_public-role_${index}`" @click="editProfessionalRoles(professionalRole)"></i> </v-flex>
                            <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.PROFESSIONAL_ROLES.VOLUNTEER_ROLES}}
                            <span class="add-edit-btn" data-qe-id="open_volunteer-roles_dialog" @click="openProfessionalDialog(memberProfileConstants.DATA_VOLUNTEER)">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex class="row__list" v-for="(professionalRole, index) in professionalRolesEdit[memberProfileConstants.DATA_VOLUNTEER]" :key="index">
                            <v-flex tag="small">{{professionalRole.name}}<i class="fas fa-pencil-alt" :data-qe-id="`edit_volunteer_${index}`" @click="editProfessionalRoles(professionalRole)"></i> </v-flex>
                            <v-flex tag="small">{{professionalRole.startDate}}</v-flex>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn flat class="primary_btn" data-qe-id="cancel_dialog_btn" @click="professionalRolesDialog = false">
                            {{appCommonConstants.CLOSE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="professionalDetailsDialog" content-class="medium">
            <ProfessionalRolesDialog v-if="professionalDetailsDialog"
                @click="handleDialog"
                @input="handleSave"
                :arrProfessionals="arrProfessionals"
                :modelProfessionals="modelProfessionals"
                :isEditProfessional="isEditProfessional"
                :headerLabel="headerLabel" 
                :isSave="isSave"
                :memberId="memberId" />
        </v-dialog>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { appCommonConstants } from "../appCommon.constants.js";
    import ProfessionalRolesDialog from "./EditDialogues/ProfessionalRolesDialog";
    import Vue from 'vue';
    import { normalizeUrl } from '@/common/utils/utils';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';

    export default {
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            enabled: false,
            professionalRolesDialog: false,
            professionalDetailsDialog: false,
            publicServiceList: [],
            externalBoardPositionList: [],
            volunteerList: [],
            professionalRolesEdit: [],
            arrProfessionals: [],
            isSave: true,
            isEditProfessional: false,
            normalizeUrl,
            modelProfessionals: {
                id: null,
                name: '',
                type: null,
                url: null,
                endDate: null,
                startDate: '',
                location: null,
                topic: null,
                description: null,
                industryCategory: null,
                subIndustryCategory: null,
                isCurrent: false,
                isEdit: false,
                isDelete: true,
                isAdd: false,
                isSuccess: false,
                isEditDialog: false,
                startMonth: '',
                endMonth: '',
                endYear: '',
                startYear: '',
                isSearch: false,
                subIndustry: [],
            },
        }),
        components: {
            ProfessionalRolesDialog,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getProfessionalRoles(this.memberId);
        },
        methods: {
            ...mapActions({
                getProfessionalRoles: `memberProfile/${storeAction.getProfessionalRoles}`,
            }),
            seeAllRoles() {
                this.enabled = !this.enabled;
            },
            openProfessionalDialog(categoryType) {
                this.professionalDetailsDialog = true;
                this.headerLabel = this.headerTextForModelDialog(categoryType);
                this.isEditProfessional = false;
                this.arrProfessionals = [];
                this.modelProfessionals.type = categoryType;                           
                this.arrProfessionals.push(Vue.util.extend({}, this.modelProfessionals));   
                this.scrollTop();            
            },
            headerTextForModelDialog(categoryType) {
                let headerText = '';
                if (categoryType === this.memberProfileConstants.DATA_EXTERNAL_BOARD_POSITION) {
                    headerText = this.memberProfileConstants.PROFESSIONAL_ROLES.EXTERNAL_BOARDS;
                } else if (categoryType === this.memberProfileConstants.DATA_PUBLIC_SERVICE) {
                    headerText = this.memberProfileConstants.PROFESSIONAL_ROLES.PUBLIC_SERVICES;
                } else if (categoryType === this.memberProfileConstants.DATA_VOLUNTEER) {
                    headerText = this.memberProfileConstants.PROFESSIONAL_ROLES.VOLUNTEER_ROLES;
                }
                return headerText;
            },      
            editProfessionalRoles(professionalRole) {
                this.arrProfessionals = [{
                    id: professionalRole.id,
                    name: professionalRole.name,
                    type: professionalRole.type,
                    endDate: professionalRole.endDate,
                    startDate: professionalRole.startDate,
                    url: professionalRole.url,
                    location: professionalRole.location,
                    topic: professionalRole.topic,
                    description: professionalRole.description,
                    industryCategory: professionalRole.industryCategory,
                    subIndustryCategory: professionalRole.subIndustryCategory,
                    isCurrent: professionalRole.isCurrent,
                    isEditDialog: true,
                    startMonth: professionalRole.startDate ? professionalRole.startDate.split(' ')[0] : null,
                    startYear: professionalRole.startDate ? Number(professionalRole.startDate.split(' ')[1]) : null,
                    endMonth: professionalRole.endDate ? professionalRole.endDate.split(' ')[0] : null,
                    endYear: professionalRole.endDate ? Number(professionalRole.endDate.split(' ')[1]) : null,
                    subIndustry: this.industory[professionalRole.industryCategory],
                }];
                this.isSave = false;
                this.professionalDetailsDialog = true;
                this.isEditProfessional = true;
                this.headerLabel = this.headerTextForModelDialog(professionalRole.type);
                this.scrollTop();
            },
            scrollTop() {
                this.$refs.professionalScroll.scrollTop = 0;
            },
            handleDialog(variable) {
                this.professionalDetailsDialog = variable;
            },
            handleSave(variable) {
                this.isSave = variable;
            },
        },
        computed: {
            ...mapGetters({
                professionalRoles: `memberProfile/${storeGetters.professionalRoles}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
            }),
            ...mapState("actionState", ["actions"]),
            isSectionVisible() {
                return this.externalBoardPositionList.length > 0 || this.publicServiceList.length > 0 || this.volunteerList.length > 0;
            },
            isSeeAllVisible() {
                return this.externalBoardPositionList.length > 1 || this.publicServiceList.length > 1 || this.volunteerList.length > 1;
            },
            isEnabled() {
                return this.enabled ?
                memberProfileConstants.SEE_LESS :
                memberProfileConstants.SEE_ALL;
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            loadGetProfessionalRolesAction() {
                return this.actions[storeAction.getProfessionalRoles];
            }, 
        },
        watch: {
            professionalRoles() {
                if (this.professionalRoles) {
                    this.externalBoardPositionList = [];
                    this.publicServiceList = [];
                    this.volunteerList = [];
                    Object.values(this.professionalRoles).forEach((x) => {
                        if (x.type === memberProfileConstants.DATA_EXTERNAL_BOARD_POSITION) {
                            this.externalBoardPositionList.push(x);
                        } else if (x.type === memberProfileConstants.DATA_PUBLIC_SERVICE) {
                            this.publicServiceList.push(x);
                        } else if (x.type === memberProfileConstants.DATA_VOLUNTEER) {
                            this.volunteerList.push(x);
                        }
                    });
                    this.professionalRolesEdit = [];
                    this.professionalRoles.forEach((x) => {
                    const list = this.professionalRolesEdit[x.type];
                    if (list) {
                        list.push(x);
                    } else {
                        this.professionalRolesEdit[x.type] = [x];
                    }
                });
                return this.professionalRolesEdit;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .roles {
        position: relative;
        border-bottom: 1px solid $ypo-open-blue-gray;
        margin-bottom: 20px;
        padding-bottom: 20px;

        strong {
            color: $ypo_blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;
            display: block;
        }

        span {
            color: $ypo-cta;
            font-size: 14px;
            line-height: 24px;
            display: block;
        }

        small {
            color: $ypo-gray-text;
            font-size: 12px;
            line-height: 24px;
            display: block;
        }

        &__dataRow {
            margin-bottom: 8px;
        }

        a{
            color: $ypo-cta;
            text-decoration: none;
        }

        .overlay {
            top: 35px;
        }
    }

    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;

        span {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            cursor: pointer;
        }

        i {
            color: $ypo-dark-background-gray;
            font-size: 14px;
            position: relative;
            left: 5px;
            margin-right: 40px;
            cursor: pointer;
        }

        em {
            color: $ypo-cta;
            font-family: "Noto Sans";
            font-size: 14px;
            line-height: 24px;
            font-style: normal;
            margin-left: 10px;
            cursor: pointer;
        }
    }

    .select-required {
        color: $ypo-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        margin-left: 608px;
    }
</style>
